import React from 'react';
import Lottie from 'lottie-react';
import CharaHappy from '../../../character/json/chara_happy.json';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicAlbumEditForm4DistributionPopup4({
  musicAlbum,
  onClose,
  onGoToHome,
  onGoToIndex,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  onClose: () => void,
  onGoToIndex: () => void,
  onGoToHome: () => void,
}) {
  const vocalTracks = musicAlbum.music_album_tracks
    .filter((musicAlbumTrack) => musicAlbumTrack.music.is_inst === 0);
  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <Lottie
        animationData={CharaHappy}
        style={{ width: '180px', margin: '-32px auto 0' }}
      />
      <form className="cake_ajax_form">
        <div className="list__body album_delivery">
          <p>
            <span className="red">配信申込が完了しました！</span>
            <br />
            配信開始されたらホームのチャットでお知らせします。
          </p>
          {vocalTracks.length > 0 && (
            <div className="coupon_box">
              <img src="/img/music/img_label.svg" alt="" className="img_label" />
              <h3>音楽配信をご利用いただいたあなたへの特別オファー</h3>
              <p>
                Frekulに「カラオケ配信サービス」という機能があるのはご存知ですか？
                <br />
                あなたの曲をカラオケJOYSOUNDに配信できる有料サービスです。
              </p>
              <img src="/img/music/img_coupon.svg" alt="" className="img_coupon" />
              <span className="text">ここから申込みで</span>
              <div className="price">
                <span className="price__big">2000</span>
                円
                <span className="price__big">OFF!!</span>
              </div>
              <p className="text__orange">【注意】このページを閉じるとお得な申し込みができなくなります。</p>
              {vocalTracks.map((musicAlbumTrack) => (
                <div className="coupon__song_list" key={musicAlbumTrack.id}>
                  <span className="coupon__song_item">{musicAlbumTrack.music.title}</span>
                  <ul>
                    <li className="bt">
                      <button
                        className="submit_bt"
                        type="button"
                        onClick={() => {
                          window.open(`/karaoke_orders?music_id=${musicAlbumTrack.music.id}&music_album_id=${musicAlbum.id}&coupon_code=music387z256w000243s520d34r5674tms`, '_blank');
                        }}
                      >
                        カラオケ配信する
                      </button>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          )}
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onGoToIndex()}>配信の管理へ</CustomButton>
              <CustomButton type="default-split" onClick={() => onGoToHome()}>ホームへ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
